import * as React from "react";
const PhotoAndVideoAgencySVG = (props) => (
  <svg
    width={25}
    height={25}
    viewBox="0 0 25 25"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M12.363 15.8125C13.7437 15.8125 14.863 14.6932 14.863 13.3125C14.863 11.9318 13.7437 10.8125 12.363 10.8125C10.9823 10.8125 9.86304 11.9318 9.86304 13.3125C9.86304 14.6932 10.9823 15.8125 12.363 15.8125Z"
      stroke="#888E9E"
      strokeWidth={1.25}
    />
    <path
      d="M4.03003 13.6148C4.03003 11.0613 4.03003 9.78452 4.65421 8.86735C4.92443 8.4703 5.27165 8.12938 5.67606 7.86408C6.27632 7.47029 7.0278 7.32954 8.17836 7.27923C8.7274 7.27923 9.20013 6.87075 9.3078 6.34215C9.46932 5.54926 10.1784 4.97852 11.0019 4.97852H13.7248C14.5483 4.97852 15.2574 5.54926 15.4189 6.34215C15.5266 6.87075 15.9993 7.27923 16.5484 7.27923C17.6989 7.32954 18.4504 7.47029 19.0507 7.86408C19.455 8.12938 19.8023 8.4703 20.0725 8.86735C20.6967 9.78452 20.6967 11.0613 20.6967 13.6148C20.6967 16.1684 20.6967 17.4453 20.0725 18.3624C19.8023 18.7594 19.455 19.1003 19.0507 19.3657C18.1165 19.9785 16.8161 19.9785 14.2152 19.9785H10.5115C7.91065 19.9785 6.61023 19.9785 5.67606 19.3657C5.27165 19.1003 4.92443 18.7594 4.65421 18.3624C4.47791 18.1033 4.35141 17.8156 4.26064 17.4785"
      stroke="#888E9E"
      strokeWidth={1.25}
      strokeLinecap="round"
    />
    <path
      d="M18.1964 10.8125H17.363"
      stroke="#888E9E"
      strokeWidth={1.25}
      strokeLinecap="round"
    />
  </svg>
);
export default PhotoAndVideoAgencySVG;
